import { FieldPattern } from '..';

import { BRANCH_ASYNC_SELECT } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class BranchComboBoxField extends DependentField {
  readonly type: string = BRANCH_ASYNC_SELECT;

  mobilePlaceholder: string;

  constructor(branchFieldData: FormFieldsType, initialValue = '') {
    super(branchFieldData, initialValue);
    this.mobilePlaceholder = branchFieldData.mobile_placeholder ?? '';
  }

  match<T>(p: FieldPattern<T>): T {
    return p.BranchComboBoxField(this);
  }
}

export default BranchComboBoxField;
